<template>
  <header class="c-header">
    <v-app-bar
      dense
      fixed
      color="blue darken-2"
      dark
    >
      <v-app-bar-nav-icon @click.prevent="showMenu = !showMenu"></v-app-bar-nav-icon>
      <v-toolbar-title class="d-none d-sm-block">{{ pageTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="ml-auto d-flex align-center">
        <v-menu v-model="internalSitesMenu" bottom offset-y :close-on-content-click="true" transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              plain
              class="mx-md-1 internal-sites-btn"
              :class="{ 'internal-sites-btn--active': internalSitesMenu }"
              v-bind="attrs"
              v-on="on"
            >
              <span class="d-none d-md-inline-block mr-1">INTERNAL SITES</span>
              <img
                width="22"
                height="22"
                src="@/assets/intranet_logo.svg"
                alt="internal sites"
                class="internal-sites-logo"
                :class="{ 'internal-sites-logo--spin': internalSitesMenu }"/>
            </v-btn>
          </template>
          <v-card class="internal-sites-card" elevation="8">
            <v-list dense class="internal-sites-list pa-0">
              <v-list-item
                href="https://sites.google.com/devcom.com/devcomintranet?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                class="internal-sites-item"
              >
                <v-list-item-icon class="mr-2 my-auto">
                  <v-icon small color="blue darken-2">mdi-home-city</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="internal-sites-title">Intranet</v-list-item-title>
                  <v-list-item-subtitle class="internal-sites-subtitle">Company portal & resources</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon small color="grey lighten-1">mdi-open-in-new</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider class="mx-2"></v-divider>
              <v-list-item
                href="https://sites.google.com/devcom.com/learning-hub-devcom/home?authuser=0"
                target="_blank"
                rel="noopener noreferrer"
                class="internal-sites-item"
              >
                <v-list-item-icon class="mr-2 my-auto">
                  <v-icon small color="amber darken-2">mdi-school</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="internal-sites-title">Learning Hub</v-list-item-title>
                  <v-list-item-subtitle class="internal-sites-subtitle">Courses & development</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon small color="grey lighten-1">mdi-open-in-new</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
        <v-menu v-model="supportMenu" bottom offset-y :close-on-content-click="false">

          <template v-slot:activator="{ on, attrs }">
            <v-btn
              plain
              class="mx-md-1"
              v-bind="attrs"
              v-on="on"
            >
              <span class="d-none d-md-inline-block mr-1">Support</span>
              <v-icon>mdi-chat-question</v-icon>
            </v-btn>
          </template>
          <div>
            <v-list dense>
              <v-list-item>
                <v-list-item-title class="text-h6">Contact us:</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item style="min-height: 50px" two-line v-for="contact in supportContacts" :key="contact.fullName">
                <v-list-item-content>
                  <v-list-item-title>{{ contact.fullName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ contact.position }}</v-list-item-subtitle>
                </v-list-item-content>
                <div class="d-flex justify-center align-center">
                  <v-icon left role="button" target="_blank" tag="a" class="contactMenuIcon" size="26"
                          :href="`https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=${contact.email}`"
                          color="blue darken-2"
                          style="align-self: flex-start; margin-top: 6px;">
                    mdi-gmail
                  </v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        left
                        icon
                        class="contactMenuIcon"
                        style="align-self: flex-start; min-width: 26px; width: 26px; height: 26px; padding: 0; margin-top: 9px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="copyForChat(contact.email)"
                      >
                        <v-img
                          :src="require('@/assets/google_chat_icon.svg')"
                          width="24"
                          height="24"
                          contain
                          position="right center"
                        />
                      </v-btn>
                    </template>
                    <span>Click to copy email to start a chat</span>
                  </v-tooltip>
                </div>
              </v-list-item>
              <v-divider></v-divider>
              <!-- Feedback Form Menu Item -->
              <v-list-item @click="showFeedbackDialog = true" style="cursor: pointer">
                <v-list-item-title>Feedback form</v-list-item-title>
              </v-list-item>

            </v-list>
            <!-- Feedback Dialog -->
            <v-dialog v-model="showFeedbackDialog" max-width="600px">
              <v-card>
                <v-card-title class="text-h6">Feedback Form</v-card-title>
                <v-card-text>
                  <v-text-field
                   label="From:"
                   :value="currentUser"
                   readonly
                   hint="This field is automatically filled with your name"
                   persistent-hint
                   />
                  <v-textarea
                    label="Please leave your feedback:"
                    v-model="feedback.message"
                    rows="4"
                    />
                  <v-file-input
                    v-model="feedback.file"
                    label="Attach file"
                    accept=".png,.jpeg,.jpg,.gif"
                    show-size
                    prepend-icon="mdi-paperclip"
                    @change="validateFile"
                    ref="fileInput"
                    hint="Only .png,.jpeg,.jpg,.gif file type allowed"
                    persistent-hint
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="sendFeedback">Send</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-menu>
        <v-menu
          bottom
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              :content="notificatonsCount"
              :value="notificatonsCount"
              color="green accent-4"
              offset-x="20"
              offset-y="20"
            >
              <v-btn
                plain
                class="mx-md-1"
                v-bind="attrs"
                v-on="on"
              >
                <span class="d-none d-md-inline-block mr-1">Notifications</span>
                <v-icon>mdi-18px mdi-message</v-icon>
              </v-btn>
            </v-badge>
          </template>
          <div>
            <NotificationsList/>
          </div>
        </v-menu>
        <v-btn
          class="mx-md-1"
          plain
          @click="openEmployeeCard"
        >
          <span class="d-none d-md-inline-block mr-1">{{ user.full_name }}</span>
          <v-icon>mdi-account</v-icon>
        </v-btn>
        <v-btn
          class="mx-md-1"
          plain
          @click.prevent="logout"
        >
          <span class="d-none d-md-inline-block mr-1">Logout</span>
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      v-model="showMenu"
      fixed
      temporary
    >
      <v-list-item>
        <v-list-item-icon>
          <v-btn icon @click.prevent="showMenu = !showMenu">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Menu</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <template
          v-for="(item, navItemKey) in navItems">
          <v-list-group
            :key="item.groupTitle"
            v-if="item.groupTitle !== '' && item.groupAvailable"
            :value="false"
          >
            <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{item.groupTitle}}</v-list-item-title>
            </v-list-item-content>
            </template>
            <v-list-item
              v-for="(item, itemKey) in item.data"
              :key="itemKey"
              link
              :disabled="item.name === currentRouteName"
              class="ml-2"
              :class="[
                item.name === currentRouteName ? 'blue darken-2': '',
                {
                  'last': itemKey === item.length
                }
              ]"
              v-show="item.available"
              @click.prevent="gotoPage(item)"
            >
              <v-list-item-content v-if="item.available">
                <v-list-item-title :class="[item.name === currentRouteName ? 'white--text': '']">
                  {{ item.title }}
                  <span v-if="item.beta" class="beta">BETA</span>
                  <span v-if="item.new" class="new green--text darken-2">New</span>
                  <span v-if="item.deprecated" class="new red--text darken-2">Deprecated</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <template v-else-if="item.groupAvailable">
            <v-list-item
              v-for="(item, itemKey) in item.data"
              :key="item.groupTitle + '_elseif' + navItemKey"
              link
              :disabled="item.name === currentRouteName"
              :class="[
                item.name === currentRouteName ? 'blue darken-2': '',
                {
                  'last': itemKey === item.length
                }
              ]"
              v-show="item.available"
              @click.prevent="gotoPage(item)"
            >
              <v-list-item-content v-if="item.available">
                <v-list-item-title :class="[item.name === currentRouteName ? 'white--text': '']">
                  {{ item.title }}
                  <span v-if="item.new" class="new green--text darken-2">New</span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action
                v-if="(item.name === 'Reporting New' || item.name === 'Reporting') && (currentRouteName === 'Reporting New' || currentRouteName === 'Reporting')">
                <v-btn
                  small
                  plain
                  text
                  style="pointer-events: auto; font-size: 12px;"
                  class="white--text px-0"
                  :class="{
                    'animate-button': currentRouteName === 'Reporting'
                  }"
                  @click.stop="switchReportingVersion(item.name)"
                >
                  {{ currentRouteName === 'Reporting New' ? 'switch back' : 'try new'}}
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </template>
          <v-list-item :class=" showSettingsFlag ? ['blue darken-2', 'white--text'] : ''" link @click="showSettings">
            <v-list-item-content>
              <v-list-item-title class="d-md-inline-block">User Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
      </v-list>
      <v-card-text class="drawer-footer">ver. 2026.03.26</v-card-text>
    </v-navigation-drawer>
    </header>
</template>

<script>
export default {
  name: 'Header',
  components: {
    NotificationsList: () => import('@/components/notifications/NotificationsList')
  },
  data () {
    return {
      showMenu: false,
      internalSitesMenu: false,
      supportMenu: false,
      showFeedbackDialog: false,
      feedback: {
        message: '',
        file: null
      },
      isDev: process.env.NODE_ENV !== 'production',
      events: undefined,
      intervalId: null,
      supportContacts: []
    }
  },
  computed: {
    currentUser () {
      if (this.user && (this.user.full_name || this.user.e_mail)) {
        return `${this.user.full_name} (${this.user.e_mail})`
      }
      return ''
    },
    employeeRoles () {
      return this.$store.getters.getEmployeeRoles
    },
    showSettingsFlag () {
      return this.$store.getters.showSettings
    },
    navItems () {
      return [
        {
          groupTitle: '',
          groupAvailable: !JSON.parse(localStorage.getItem('reportingNew'))?.CurrentMonth,
          data: [
            {
              title: 'Reporting',
              name: 'Reporting',
              available: true
            }
          ]
        },
        {
          groupTitle: '',
          groupAvailable: !!JSON.parse(localStorage.getItem('reportingNew'))?.CurrentMonth,
          data: [
            {
              title: 'Reporting',
              name: 'Reporting New',
              available: true,
              new: true
            }
          ]
        },
        {
          groupTitle: 'Human Resources',
          groupAvailable: true,
          data: [
            {
              title: 'Employee',
              name: 'Employee',
              available: true
            },
            {
              title: 'Employee Skills',
              name: 'EmployeeSkills',
              available: true
            },
            {
              title: 'Anniversary',
              name: 'Anniversary',
              available: true
            }
          ]
        },
        {
          groupTitle: 'Project Management',
          groupAvailable: (this.employeeRoles.manager.val || this.employeeRoles.hr.val || this.employeeRoles.financier.val),
          data: [
            {
              title: 'Projects',
              name: 'Projects',
              available: true
            },
            {
              title: 'Task editor',
              name: 'EditTasks',
              available: true
            },
            {
              title: 'Reports',
              new: false,
              name: 'ManagerReports',
              available: true
            },
            {
              title: 'General Reports',
              name: 'GeneralReports',
              available: false,
              deprecated: true
            },
            {
              title: 'Clients',
              name: 'Clients',
              available: true
            },
            {
              title: 'Summary',
              name: 'Summary',
              available: true
            },
            {
              title: 'Jira Velocity',
              name: 'JiraVelocity',
              available: false
            }
          ]
        },
        {
          groupTitle: 'Finance',
          groupAvailable: (this.employeeRoles.financier.val || this.employeeRoles.hr.val) && !this.officeManager && !this.executiveAssistant,
          data: [
            {
              title: 'Absence transfer',
              name: 'AbsenceTransfer',
              available: this.employeeRoles.financier.val
            },
            {
              title: 'Requests',
              name: 'Requests',
              available: (this.employeeRoles.financier.val || this.employeeRoles.hr.val)
            },
            {
              title: 'Payroll',
              name: 'Payroll',
              available: this.employeeRoles.financier.val
            },
            {
              title: 'Payroll Documents',
              name: 'PayrollDocuments',
              available: this.employeeRoles.financier.val
            },
            {
              title: 'Invoices',
              name: 'Invoices',
              available: this.employeeRoles.financier.val
            }
          ]
        },
        {
          groupTitle: 'Metrics',
          groupAvailable: this.employeeRoles.manager.val || this.employeeRoles.hr.val || this.employeeRoles.financier.val,
          data: [
            {
              title: 'PR Matrix Summary',
              name: 'PRMatrixSummary',
              // available: (this.employeeRoles.manager.val || this.employeeRoles.hr.val || this.employeeRoles.financier.val)
              available: false
            },
            {
              title: 'PR Matrix Charts',
              name: 'PRMatrixCharts',
              // available: (this.employeeRoles.manager.val || this.employeeRoles.hr.val || this.employeeRoles.financier.val)
              available: false
            },
            {
              title: 'Employee Project Period',
              name: 'EmployeeProjectPeriod',
              available: (this.employeeRoles.manager.val || this.employeeRoles.hr.val || this.employeeRoles.financier.val)
            },
            {
              title: 'Project KPIs',
              name: 'ProjectKPIs',
              available: (this.employeeRoles.manager.val || this.employeeRoles.hr.val || this.employeeRoles.financier.val)
            }
          ]
        },
        {
          groupTitle: '',
          groupAvailable: (this.employeeRoles.financier.val || this.employeeRoles.hr.val || this.employeeRoles.assets_manager.val) && !this.officeManager && !this.executiveAssistant,
          data: [
            {
              title: 'Assets',
              name: 'Assets',
              available: true
            }
          ]
        },
        {
          groupTitle: 'Admin',
          groupAvailable: (this.employeeRoles.financier.val || this.employeeRoles.hr.val || this.employeeRoles.assets_manager.val || this.employeeRoles.manager.val) && !this.officeManager && !this.executiveAssistant,
          data: [
            {
              title: 'Assets',
              name: 'AdminAssets',
              available: (this.employeeRoles.assets_manager.val || this.employeeRoles.financier.val || this.employeeRoles.hr.val)
            },
            {
              title: 'Human Resources',
              name: 'AdminHumanResources',
              available: (this.employeeRoles.financier.val || this.employeeRoles.hr.val)
            },
            {
              title: 'Project Management',
              name: 'AdminProjectManagement',
              available: (this.employeeRoles.financier.val || this.employeeRoles.hr.val || this.employeeRoles.manager.val)
            },
            {
              title: 'System',
              name: 'AdminSystemSettings',
              available: this.employeeRoles.financier.val || this.employeeRoles.hr.val
            },
            {
              title: 'Notification',
              name: 'AdminEmailsMailingManagement',
              available: this.employeeRoles.financier.val || this.employeeRoles.hr.val
            },
            {
              title: 'Documents',
              name: 'AdminDocumentsManagement',
              available: this.employeeRoles.financier.val || this.employeeRoles.hr.val
            },
            {
              title: 'PRM Sync Setup',
              name: 'PrmSyncAdmin',
              available: this.employeeRoles.hr.val || this.employeeRoles.financier.val
            }
          ]
        }
      ]
    },
    employeeLink () {
      if (this.$route.name === 'Employee') return `${this.user.employee_id}`
      return `employee/${this.user.employee_id}`
    },
    notificatonsCount () {
      return this.$store.getters.getNotifications.length
    },
    user () {
      return this.$store.getters.getUser
    },
    currentRouteName () {
      return this.$route.name
    },
    pageTitle () {
      let title = ''
      for (const group of this.navItems) {
        let found = false
        for (const item of group.data) {
          if (item.name === this.currentRouteName) {
            title = group.groupTitle === 'Admin' ? 'Admin Settings' : item.title
            found = true
            break
          }
        }
        if (found) {
          break
        }
      }
      return title
    },
    officeManager () {
      const position = this.$store.getters.getCurrentUserPosition
      return position === 'Office Manager' && this.employeeRoles.hr.val
    },
    executiveAssistant () {
      const position = this.$store.getters.getCurrentUserPosition
      return position === 'Executive Assistant' && this.employeeRoles.hr.val
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
  mounted () {
    this.getNotifications()
    this.subscribeToNotification()
    this.getUserPosition()
    this.getSupportContacts()
    this.intervalId = setInterval(this.getNotifications, 5000)
  },
  destroyed () {
    this.events.close()
  },
  methods: {
    validateFile (file) {
      if (!file) return
      const allowed = ['image/png', 'image/jpeg', 'image/gif']
      if (!allowed.includes(file.type)) {
        this.feedback.file = null
        if (this.$refs.fileInput) {
          this.$refs.fileInput.reset()
        }
        this.$emit('error', 'Only PNG, JPEG, and GIF files are allowed.')
        alert('Invalid file type. Only PNG, JPEG, and GIF are supported.')
      }
    },
    sendFeedback () {
      if (!this.feedback.message) {
        this.$store.dispatch('setError', { errorMsg: 'Feedback cannot be empty.' })
        return
      }

      const formData = new FormData()
      formData.append('from', this.currentUser)
      formData.append('message', this.feedback.message)
      if (this.feedback.file) {
        formData.append('file', this.feedback.file)
      }

      this.axios.post('/api/emails/send-feedback', formData, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setSuccess', { successMsg: 'Feedback sent successfully.' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })

      this.showFeedbackDialog = false
      this.feedback = { message: '', file: null }
    },
    getSupportContacts () {
      this.axios.get('/api/support_contacts', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.supportContacts = result.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    switchReportingVersion (name) {
      if (name === 'Reporting') {
        localStorage.setItem('reportingNew', JSON.stringify({ CurrentMonth: new Date().toISOString().substring(0, 10) }))
        this.$router.replace({ name: 'Reporting New' })
        this.navItems[0].groupAvailable = false
        this.navItems[1].groupAvailable = true
      } else {
        localStorage.removeItem('reportingNew')
        this.$router.replace({ name: 'Reporting' })
        this.navItems[1].groupAvailable = false
        this.navItems[0].groupAvailable = true
      }
    },
    subscribeToNotification () {
      this.events = new EventSource(`${process.env.VUE_APP_BASE_URL}/api/notifications-subscrible/${this.user.employee_id}`)

      this.events.onmessage = (event) => {
        const e = JSON.parse(event.data).event
        if (e === 'unblock_projects') {
          this.$store.dispatch('blockProject', { projectID: null })
          this.$store.dispatch('updateTasks', { update: true })
        }
        if (e === 'salary_success') {
          this.$store.dispatch('showOverlay', { show: false })
          this.$store.dispatch('updateSalary', { update: true })
        }
      }
    },
    getNotifications () {
      const url = `/api/notifications?_=${new Date().getTime()}`
      this.axios.get(url, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.$store.dispatch('setNotifications', { notifications: result.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    showSettings () {
      this.$store.dispatch('showSettings', { show: true })
      this.showMenu = false
    },
    logout () {
      this.$store.dispatch('setUserData', {
        userData: {
          e_mail: null,
          employee_id: null,
          full_name: null,
          login: null,
          token: null,
          refresh_token: null
        }
      })
      this.$router.replace({ name: 'Login' })
    },
    gotoPage (item) {
      if (item.available) {
        this.$router.push({ name: item.name })
      }
    },
    openEmployeeCard () {
      this.axios.get(`/api/employee/${this.user.employee_id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('employeeDetailsScreen', {
          show: true,
          employee: res.data[0],
          edit: false
        })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    copyForChat (email) {
      navigator.clipboard.writeText(email).then(() => {
        const message = 'Email copied! Now paste it into the Google Chat search bar.'
        this.$store.dispatch('setSuccess', { successMsg: message })
      }, () => {
        this.$store.dispatch('setError', { errorMsg: "Email wasn't copied" })
      })
    },
    getUserPosition () {
      this.axios.get(`/api/get_user_position/${this.user.employee_id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setCurrentUserPosition', { employeePosition: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>

<style lang="scss">
  .last {
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    font-size: 12px;
  }
  .c-header {
    z-index: 1000;
  }
  .beta, .new, .deprecated {
    font-size: 9px;
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    display: inline-block;
    transform: translate(0, -5px);
  }
  .contactMenuIcon{
    text-decoration: none;
    margin-top: 5px;
    align-self: flex-start;
  }
  .v-btn--icon.contactMenuIcon {
  min-width: 26px !important;
  height: 26px !important;
}
  .contactMenuIcon:hover{
    transform: scale(1.2);
    transition: all .2s ease-in-out;
  }
  .internal-sites-btn {
    transition: all 0.2s ease-in-out;
  }
  .internal-sites-btn--active {
    background: rgba(255, 255, 255, 0.1) !important;
  }
  .internal-sites-logo {
    transition: transform 0.3s ease-in-out;
  }
  .internal-sites-logo--spin {
    transform: rotate(180deg);
  }
  .internal-sites-card {
    border-radius: 6px !important;
    overflow: hidden;
    min-width: 180px;
  }
  .internal-sites-list {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  }
  .internal-sites-item {
    cursor: pointer;
    padding: 6px 10px !important;
    min-height: 36px !important;
    transition: all 0.2s ease-in-out;
    position: relative;
    overflow: hidden;
  }
  .internal-sites-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 3px;
    background: #1976D2;
    transform: scaleY(0);
    transition: transform 0.2s ease-in-out;
  }
  .internal-sites-item:hover {
    background: rgba(25, 118, 210, 0.08) !important;
  }
  .internal-sites-item:hover::before {
    transform: scaleY(1);
  }
  .internal-sites-item:hover .internal-sites-title {
    color: #1976D2;
  }
  .internal-sites-item:hover .v-list-item__action .v-icon {
    color: #1976D2 !important;
    transform: translateX(2px);
  }
  .internal-sites-title {
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.1px;
    transition: color 0.2s ease-in-out;
  }
  .internal-sites-subtitle {
    font-size: 10px;
    opacity: 0.7;
    margin-top: 0;
  }
  .internal-sites-item .v-list-item__action .v-icon {
    transition: all 0.2s ease-in-out;
  }
  .animate-button {
    animation: pulse 1s infinite;
  }

  .drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.62;
    }
    50% {
      transform: scale(1.05);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0.62;
    }
  }
</style>
